import React from 'react'

import { LntButton, LntSelect, LntTextArea } from '@app/components/base'

import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { TEMPLATES_EDITOR_KEY } from '@app/constants/queryKeys'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import { getTemplates } from '@app/api/routes/templates'

import { getFilterTemplatesFromEntities } from '@app/utils/entitiesAdapters'

import styles from './styles.module.scss'

import type { LntSelectProps } from '@app/components/base/Select/types'
import type { EditCommentWithSamplesProps } from './types'

const commonSelectProps: LntSelectProps = {
  mode: 'multiple',
  showArrow: true
}

export const EditCommentWithSamples: React.FC<EditCommentWithSamplesProps> = props => {
  const { sampleIds, message, onPatchComment, onChangeMessage, onChangeSampleIds, onCancel } = props

  const handleChangeSampleIds = (value: unknown): void => {
    onChangeSampleIds(value as number[])
  }

  const handleChangeMessage = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
    const { value } = event.target

    onChangeMessage(value)
  }

  return (
    <div className={ styles.editComment }>
      <LntSelect
        { ...commonSelectProps }
        placeholder={ FILTERS_PLACEHOLDERS.samples }
        onChange={ handleChangeSampleIds }
        defaultValue={ sampleIds }
        querySelect={ {
          queryKey: [TEMPLATES_EDITOR_KEY.templatesEditorItems],
          queryFn: getTemplates,
          select: getFilterTemplatesFromEntities
        } }
      />
      <LntTextArea
        showCount
        maxLength={ 250 }
        size={ SIZE.large }
        placeholder={ FILTERS_PLACEHOLDERS.comment }
        onChange={ handleChangeMessage }
        defaultValue={ message ?? '' }
      />
      <div className={ styles.editComment__buttons }>
        <LntButton
          type={ BUTTON_TYPE.secondary }
          size={ SIZE.small }
          onClick={ onCancel }
        >
          Отмена
        </LntButton>
        <LntButton
          type={ BUTTON_TYPE.primary }
          size={ SIZE.small }
          onClick={ onPatchComment }
        >
          Сохранить
        </LntButton>
      </div>
    </div>
  )
}
